import React from 'react';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';

export default function ChatMenu() {
    const {locale} = useRouter();
    const items = [
        {
            id: 1,
            label: getLocaleContent(locale, 'page.menu-chat.zalo-chat'),
            icon: '/bw_image/ic_zalo.svg',
            link: 'https://zalo.me/4464491691050007249',
        },
        {
            id: 2,
            label: getLocaleContent(locale, 'page.menu-chat.international-hospital'),
            icon: '/bw_image/ic_fb_2.svg',
            link: 'https://m.me/bvquoctethainguyen',
        },
        {
            id: 3,
            label: getLocaleContent(locale, 'page.menu-chat.pho-yen-hospital'),
            icon: '/bw_image/ic_fb_2.svg',
            link: 'https://m.me/benhvientnhphoyen',
        },
        {
            id: 4,
            label: getLocaleContent(locale, 'page.menu-chat.viet-yen-hospital'),
            icon: '/bw_image/ic_fb_2.svg',
            link: 'https://m.me/benhvientnhvietyen',
        },
    ];

    return (
        <div className="menu-chat">
            {items.map(item => (
                <a key={item.id} href={item.link} target="_blank" rel="noopener noreferrer" className="menu-chat-item">
                    <img src={item.icon} alt="" />
                    <span>{item.label}</span>
                </a>
            ))}
        </div>
    );
}
